import request from './adminRequest'

export const jobCounselingApi = {
  listJobCounseling (params) {
    return request.get('/jobCounselings', { params: params })
  },
  getJobCounseling (id) {
    return request.get('/jobCounselings/' + id)
  },
  saveJobCounseling (data) {
    return request.post('/jobCounselings', data)
  },
  updateJobCounseling (id, data) {
    return request.put('/jobCounselings/' + id, data)
  },
  deleteJobCounseling (id) {
    return request.delete('/jobCounselings/' + id)
  },

}
export default jobCounselingApi
